import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labelV2: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.request-type-selector.label-v-2',
		defaultMessage: 'Default request type',
		description:
			'Label for select field to set the default request type for the virtual service agent.',
	},
	label: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.request-type-selector.label',
		defaultMessage: 'Virtual agent default request type',
		description: 'Label for select field to set the default request type for the virtual agent.',
	},
	helperMessageV2: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.request-type-selector.helper-message-v-2',
		defaultMessage:
			'Issues created by the virtual service agent will use this request type. You can always change this later in Settings.',
		description:
			'Helper message for select field to set the default request type for the virtual service agent.',
	},
	helperMessage: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.request-type-selector.helper-message',
		defaultMessage:
			'Issues created by the virtual agent will use this request type. You can always change this later in Settings.',
		description:
			'Helper message for select field to set the default request type for the virtual agent.',
	},
	requestTypeNotSelectedError: {
		id: 'servicedesk-settings-virtual-agent-landing.action-section.create-virtual-agent-section.request-type-selector.request-type-not-selected-error',
		defaultMessage: 'Select a request type to continue',
		description:
			'Error message displayed when a user attempts to create a virtual service agent without selecting a default request type.',
	},
});
